import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Network, Bot, DollarSign, Brain, Users, AlertTriangle, FileCheck, LogOut } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import BrandMark from '@/components/atoms/BrandMark';

const links = [
  { label: 'Commander', href: '/sovereign', icon: LayoutDashboard },
  { label: 'Mesh', href: '/sovereign/mesh', icon: Network },
  { label: 'Agents', href: '/sovereign/agents', icon: Bot },
  { label: 'Revenue', href: '/sovereign/revenue', icon: DollarSign },
  { label: 'Cortex', href: '/sovereign/cortex', icon: Brain },
  { label: 'ERT', href: '/sovereign/ert', icon: Users },
  { label: 'Alerts', href: '/sovereign/alerts', icon: AlertTriangle },
  { label: 'Audit', href: '/sovereign/audit', icon: FileCheck },
];

const SovereignLayout = ({ children }) => {
  const location = useLocation();
  const { logout } = useAuth();

  return (
    <div className="min-h-screen bg-obsidian text-signal flex">
      <aside className="hidden lg:flex w-56 flex-col border-r border-violet/20 bg-[#08061A]">
        <div className="p-4 border-b border-violet/20">
          <Link to="/" className="flex items-center gap-2.5">
            <img src="/logo-drklynx-sm.png" alt="DrkLynX" className="w-12 h-12 rounded-md" />
            <BrandMark size="md" />
          </Link>
          <div className="font-mono text-[9px] text-violet/60 mt-1 uppercase tracking-wider">Sovereign Console</div>
        </div>
        <nav className="flex-1 py-3 overflow-y-auto" aria-label="Sovereign navigation">
          {links.map((l) => {
            const active = location.pathname === l.href;
            return (
              <Link key={l.href} to={l.href} data-testid={`sov-nav-${l.label.toLowerCase()}`}
                className={`flex items-center gap-3 px-4 py-2.5 text-sm transition-colors duration-fast mx-2 rounded-md ${active ? 'bg-violet/10 text-violet' : 'text-steel hover:text-signal hover:bg-signal/5'}`}>
                <l.icon className="w-4 h-4" /> {l.label}
              </Link>
            );
          })}
        </nav>
        <div className="p-4 border-t border-violet/20">
          <div className="font-mono text-[10px] text-gold uppercase tracking-wider mb-1">Commander Alpha Prime</div>
          <button onClick={logout} className="flex items-center gap-2 text-sm text-steel-muted hover:text-error transition-colors duration-fast">
            <LogOut className="w-4 h-4" /> Disengage
          </button>
        </div>
      </aside>
      <div className="flex-1 min-w-0">
        <main className="p-6 lg:p-8">{children}</main>
      </div>
    </div>
  );
};

export default SovereignLayout;
